<template>
  <v-dialog max-width="450px" v-model="internalShow">
    <v-card v-if="!cartMerge">
      <v-card-title class="justify-space-between">
        <div>
          <v-tabs v-model="tab" bg-color="transparent">
            <v-tab :value="0">
              <div>
                <v-icon class="mr-1">mdi-shield-key</v-icon>
                {{ $t('profile.tab-login') }}
              </div>
            </v-tab>
            <v-tab :value="1">
              <div>
                <v-icon class="mr-1">mdi-cash-register</v-icon>
                {{ $t('profile.tab-register') }}
              </div>
            </v-tab>
          </v-tabs>
        </div>

        <v-btn icon @click="internalShow = false" class="clickable">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-tabs-window v-model="tab">
          <v-tabs-window-item :value="0">
            <v-form ref="loginForm" v-model="validLogin" @submit.prevent="submitLogin">
              <v-text-field
                v-model="loginEmail"
                :rules="[rules.required, rules.email]"
                :label="$t('profile.email')"
                type="email"
                name="email"
                autocomplete="email"
                required
              ></v-text-field>
              <v-text-field
                v-model="loginPassword"
                :rules="[rules.required]"
                :label="$t('profile.password')"
                type="password"
                name="password"
                autocomplete="current-password"
                required
              ></v-text-field>
              <v-checkbox v-model="rememberMe" :label="$t('profile.remember-me')"></v-checkbox>

              <div class="d-flex justify-center">
                <v-btn :disabled="!validLogin" variant="flat" color="primary" class="mt-3 clickable" type="submit">
                  <v-icon class="mr-3">mdi-shield-key</v-icon>
                  {{ $t('profile.login') }}
                </v-btn>
              </div>
            </v-form>
          </v-tabs-window-item>

          <v-tabs-window-item :value="1">
            <post-registration-tooltip
              v-if="showPostRegistrationTooltip"
              :token="registeredActivationId"
              :email="registerEmail"
            ></post-registration-tooltip>

            <v-form v-else ref="registerForm" v-model="validRegister">
              <v-text-field
                v-model="registerEmail"
                :rules="[rules.required, rules.email]"
                :label="$t('profile.email')"
                type="email"
                required
              ></v-text-field>
              <v-text-field
                v-model="registerPassword"
                :rules="[rules.required]"
                :label="$t('profile.password')"
                type="password"
                required
              ></v-text-field>
              <v-text-field
                v-model="registerConfirmPassword"
                :rules="[rules.required, rules.matchPassword]"
                :label="$t('profile.confirm-password')"
                type="password"
                required
              ></v-text-field>

              <div class="d-flex justify-center">
                <v-btn :disabled="!validRegister" variant="flat" color="primary" class="mt-3 clickable" @click="submitRegistration">
                  <v-icon class="mr-3">mdi-cash-register</v-icon>
                  {{ $t('profile.register') }}
                </v-btn>
              </div>
            </v-form>
          </v-tabs-window-item>
        </v-tabs-window>
      </v-card-text>
    </v-card>

    <CartMergePage
      v-show="cartMerge"
      ref="cartMergePage"
      @manualMergeDone="
        cartMerge = false;
        finishLogin();
      "
    ></CartMergePage>
  </v-dialog>
</template>

<script>
import api from '@/venit/components/cortona-venit/services/api';
import PostRegistrationTooltip from '@/venit/components/cortona-venit/components/login/profile/activation/PostRegistrationTooltip.vue';
import CartMergePage from '@/venit/components/cortona-venit/components/cart/CartMergePage.vue';
import { useAccountStore } from '@/stores/account';

export default {
  components: { CartMergePage, PostRegistrationTooltip },
  props: {
    show: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      cartMerge: false,
      internalShow: this.show,
      showPostRegistrationTooltip: false,
      tab: 0,
      validLogin: false,
      validRegister: false,
      loginEmail: '',
      loginPassword: '',
      rememberMe: true,
      registerEmail: '',
      registerPassword: '',
      registerConfirmPassword: '',
      registeredActivationId: null,
      rules: {
        required: value => !!value || this.$i18n.t('profile.required'),
        email: value => /.+@.+\..+/.test(value) || this.$i18n.t('profile.email-invalid'),
        matchPassword: value => value === this.registerPassword || this.$i18n.t('profile.password-invalid'),
      },
    };
  },
  watch: {
    show(val) {
      this.internalShow = val;
    },
    internalShow(val) {
      this.$emit('update:show', val);
    },
  },
  methods: {
    async submitLogin() {
      if (this.validLogin) {
        const accountStore = useAccountStore();
        let loggedIn = await accountStore.login({
          email: this.loginEmail,
          password: this.loginPassword,
          rememberMe: this.rememberMe,
        });
        if (loggedIn) {
          let cartMergePage = this.$refs.cartMergePage;
          if (!cartMergePage.needsManualMerge()) {
            if (cartMergePage.needsSimpleMerge()) await cartMergePage.merge();
            this.finishLogin();
          } else this.cartMerge = true;
        }
      }
    },

    finishLogin() {
      this.internalShow = false;
      this.$emit('loggedIn');
    },

    async submitRegistration() {
      if (this.validRegister) {
        let registered = await api.register(this.registerEmail, this.registerPassword, this.$i18n.locale.toUpperCase());
        if (registered) {
          this.showPostRegistrationTooltip = true;
          this.registeredActivationId = registered.activationId;
        }
      }
    },
  },
};
</script>

<style scoped></style>